import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Input } from 'components/ui/input';
import { cn } from 'lib/utils';

interface FormFieldProps {
  name: string;
  label: string;
  placeholder?: string;
  error: any;
  children?: React.ReactNode;
  className?: string;
}

const FormField: React.FC<FormFieldProps> = ({ name, label, placeholder, error, children, className }) => {
  const { register } = useFormContext();

  return (
    <div className={cn("flex flex-col gap-2 w-full", className)}>
      <label className="text-sm">{label}</label>
      {children ? (
        children
      ) : (
        <Input
          placeholder={placeholder}
          {...register(name)}
          className={cn(error && 'border-destructive')}
        />
      )}
    </div>
  );
};

export default FormField;